import React from "react";

const FormSectionTitle = ({ children, className = "" }) => {
  return (
    <h2 className={`text-md font-semibold text-gray-800 mb-4 ${className}`}>
      {children}
    </h2>
  );
};

export default FormSectionTitle;